/* eslint-disable class-methods-use-this */
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    // Store the header element from outside the component
    this.header = document.querySelector("#shopify-section-header");
    // Store the modal-overlay element
    this.cloak = document.querySelector(".modal-overlay");
    // Store the <details> element
    this.mainDetails = this.querySelector("details");
    // Store the <summary> element
    this.summary = this.querySelector("summary");
    // Store the <div class="nav-drawer"> element
    this.navDrawer = this.querySelector(".nav-drawer");
  }

  connectedCallback() {
    // Check if mainDetails exists before proceeding
    if (!this.mainDetails) {
      console.warn("No details element found");
      return;
    }
    if (!this.header.contains(this)) {
      console.warn(`This details element - ${this} is not a child of the header`);
      return;
    }
    // this.addEventListener(
    //   'keyup',
    //   (e) => e.key.toUpperCase() === 'ESCAPE' && this.close(e)
    // );

    // this.mainDetails.addEventListener(
    //   "focusout",
    //   (e) => !this.contains(document.activeElement) && this.close(e)
    // );
    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));

    this.mainDetails.addEventListener("click", (e) => {
      if (!this.mainDetails.open) {
        this.open();
        this.navDrawer.focus();
      } else {
        if (!this.mainDetails.contains(e.target)) {
          this.close(e);
        } else {
          if (e.target.closest('summary') === this.summary) {
            this.close(e);
          }
          console.log("currentTarget", e.currentTarget);
          console.log("contains", e.target);
        }
      }
    });
  }

  onKeyUp(e) {
    if (e.key.toUpperCase() !== "ESCAPE") return;
    const openDetailsElement = e.target.closest("details[open]");
    if (!openDetailsElement) return;

    this.close(e);
  }

  onFocusOut(e) {
    // This setTimeout ensures the close method is called after the focus change has been processed by the browser
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close(e);
    });
  }

  onAnimationEnd(cb) {
    this.navDrawer.addEventListener("animationend", cb, { once: true });
  }

  open() {
    // Add Nav Open class to the header
    this.header.classList.add("nav-open");
    // Chrome sometimes has a hiccup and gets stuck.
    if (this.navDrawer.classList.contains("animation")) {
      this.navDrawer.classList.remove("animation", "collapsing");
      void this.summary.offsetWidth;
      return;
    }
    // Request an animation frame to force Safari 16 to actually perform the animation
    requestAnimationFrame(() => this.navDrawer.classList.add("animation"));
    this.onAnimationEnd(() => this.navDrawer.classList.remove("animation"));
    // Add the is-open class to the parent element
    this.classList.add("is-open");
    // Add necessary classes to the body and cloak
    document.body.classList.add("overflow-hidden");
    if (this.cloak.getAttribute("open") === null) {
      this.cloak.setAttribute("open", true);
    }
    console.log("nav open from", this);
    window.clearTimeout();
  }

  close(e) {
    console.trace();
    e.preventDefault();
    const contentElement = this.navDrawer;
    const onAnimationEnd = (cb) =>
      contentElement.addEventListener("animationend", cb, { once: true });
    // request an animation frame to force Safari 16 to actually perform the animation
    requestAnimationFrame(() => contentElement.classList.add("animation"));
    onAnimationEnd(() => contentElement.classList.remove("animation"));

    const isDetailsOpen = this.mainDetails.hasAttribute("open");
    if (isDetailsOpen) {
      e.preventDefault();
      this.navDrawer.classList.add("collapsing");
      this.onAnimationEnd(() => {
        console.log("animation ending", this.mainDetails);
        this.navDrawer.classList.remove("collapsing");
        this.mainDetails.removeAttribute("open");
        this.classList.remove("is-open");
        /* If no other details are open, remove the nav-open class from the header, remove the overflow-hidden class from the body and remove the open attribute from the cloak */
        if (this.header.querySelector("details[open]") === null) {
          this.header.classList.remove("nav-open");
          document.body.classList.remove("overflow-hidden");
          this.cloak.removeAttribute("open");
        }
      });
    }
  }

  disconnectedCallback(e) {
    this.removeEventListener("keyup", this.onKeyUp);

    this.mainDetails.removeEventListener("focusout", this.onFocusOut(e));
  }
}

customElements.define("details-disclosure", DetailsDisclosure);
